import React, { Fragment } from 'react'
import LogoDropDown from './LogoDropDown'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import {langPrefix} from 'shared/i18n/react'

const LogoItem = (props) => {
  const pathPrefix = langPrefix().replace('/', '')
  return (
    <Fragment>
      {/* <a href="javascript:;" onClick={this.props.toggleWithId}> */}
      <Link to={`/${pathPrefix}`}>
        <span className="logo"></span>
        {/* <i className="icon-arrow-down navbar-subnav-indicator"></i> */}
      </Link>
      <LogoDropDown {...props} id='soompi' />
    </Fragment>
  )
}

LogoItem.propTypes = {
  id: PropTypes.string,
  toggleWithId: PropTypes.func,
  dropdown: PropTypes.string
}

export default LogoItem



// WEBPACK FOOTER //
// ./assets/js/components/navigations/logo/LogoItem.jsx